import { useState } from 'react';

export const useHovered = (
  containerRef: React.RefObject<HTMLDivElement>,
  isTablet: boolean,
  isError?: boolean,
) => {
  const [isItemHovered, setIsItemHovered] = useState(false);

  const handleShowButton = () => {
    if (isTablet) {
      return;
    }
    setTimeout(() => {
      if (containerRef.current && containerRef.current.matches(':hover')) {
        setIsItemHovered(true);
      }
    }, 50);
  };
  const handleHideButton = () => {
    if (isError) {
      return;
    }
    setTimeout(() => {
      // If the container is no longer hovered, update the state
      if (containerRef.current && !containerRef.current.matches(':hover')) {
        setIsItemHovered(false);
      }
    }, 50); // 50ms delay; adjust as needed
  };
  return { isItemHovered, handleShowButton, handleHideButton, setIsItemHovered };
};
